module.exports = {"141121100":"凤城镇","141121101":"开栅镇","141121102":"南庄镇","141121103":"南安镇","141121104":"刘胡兰镇","141121105":"下曲镇","141121106":"孝义镇","141121200":"南武乡","141121201":"西城乡","141121202":"北张乡","141121203":"马西乡","141121204":"西槽头乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141121.json
// module id = 337
// module chunks = 0